// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5183":"b8fcf9b0","5577":"920968ac"}[chunkId] + ".chunk.css";
};